import React, { useEffect, useState } from "react";
import "./EWayBill.scss";
import FullScreenDialog from "../../commons/FullScreenDilog/FullScreenDilog";

import {
  BusinessAddressIcon,
  CustomerSupplierDetailsIcon,
  DocumentIcon,
  InfoViolet,
  RedErrorIcon,
  TruckIcon,
  ValueIcon,
} from "../../../assets/images";
import { formatDate } from "../../../utils/commonFunctions";
import { EWayBillReviewDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { EWayBill_HEADERS } from "../../../constant/invoiceListConst";
import EWayBillTableData from "./EWayBillTableData";
import { TableHeader, TableLoader } from "../../commons";

import {
  ExtendEWayBillPayloadType,
  GenerateEWayBillPayloadType,
} from "../../../commonTypes/invoiceGenerationTypes";

import toast from "react-hot-toast";
import EWayBillCancel, { CANCEL_EWAYBILL_OPTION } from "./EWayBillCancel";
import EWayBillAction from "./EWayBillAction";
import EWayBillGenerate from "./EWayBillGenerate";
import EWayBillExtend from "./EWayBillExtend";

type AppProps = {
  success: number | null;
  isOpen: boolean;
  data: EWayBillReviewDataType;
  fetching: boolean;
  eWayBillAt: string | null;
  eWayBillError: string;
  isEWayPresent: number;
  togglePreviewEWayBill: (id?: string) => void;
  generateEWayBill: GenerateEWayBillPayloadType;
  setGenerateEWayBill: React.Dispatch<
    React.SetStateAction<GenerateEWayBillPayloadType>
  >;
  handleEWayBillGenerate: () => void;
  cancelEWayBillComment: string;
  setCancelEWayBillComment: (data: string) => void;
  eWayBillRadioValue: string;
  setEWayBillRadioValue: (data: string) => void;
  handleCancelEWayBill: () => void;
  setIsEWayPresent: React.Dispatch<React.SetStateAction<number>>;
  isEWayBillGenerate?: boolean;
  isEWayBillCancel?: boolean;
  isEWayBillDownload?: boolean;
  isEWayBillExtend?: boolean;
  message: string | null;
  clientCode: null | number;
  eWayBillInvoiceId: string | number;
  type: string;
  token: string | null;
};

const EWayBillModal = ({
  isOpen,
  data,
  success,
  eWayBillAt,
  eWayBillError,
  togglePreviewEWayBill,
  fetching,
  isEWayPresent,
  generateEWayBill,
  setGenerateEWayBill,
  handleEWayBillGenerate,
  cancelEWayBillComment,
  setCancelEWayBillComment,
  eWayBillRadioValue,
  setEWayBillRadioValue,
  handleCancelEWayBill,
  setIsEWayPresent,
  isEWayBillGenerate,
  isEWayBillCancel,
  isEWayBillDownload,
  message,
  clientCode,
  eWayBillInvoiceId,
  type,
  token,
  isEWayBillExtend,
}: AppProps) => {
  const [showFillForm, setShowFillForm] = useState(false);
  const [showCancelForm, setShowCancelFillForm] = useState(false);
  const [showExtendFillForm, setShowExtendFillForm] = useState(false);
  const [inputDetailsError, setInputDetailsError] = useState({
    transporterName: "",
    transporterId: "",
    transportationDistance: "",
    transportationMode: "",
    vehicleType: "",
    vehicleNumber: "",
    subSupply: "",
    transporterDocumentNumber: "",
    transporterDocumentDate: "",
    transactionType: "",
  });

  const [eWayBillExtendForm, setEWayBillExtendForm] =
    useState<ExtendEWayBillPayloadType>({
      client_code: clientCode,
      invoice_id: eWayBillInvoiceId,
      invoice_type: type,
      remaining_distance: null,
      extend_validity_reason: "",
      extend_remarks: "",
      from_pincode: null,
      consignment_status: "",
      transit_type: "",
      address_line1: "",
      address_line2: "",
      address_line3: "",
      transporter_document_date: null,
      transporter_document_number: "",
      mode_of_transport: "",
      vechile_number: "",
      current_place_of_consignor: "",
      current_state_of_consignor: "",
      type: type,
    });
  const [extendInputDetailsError, setExtendInputDetailsError] = useState({
    remainingDistance: "",
    extendValidityReason: "",
    extendRemarks: "",
    fromPincode: "",
    consignmentStatus: "",
    transitType: "",
    transporterDocumentDate: "",
    transporterDocumentNumber: "",
    modeOfTransport: "",
    vechileNumber: "",
    currentStateOfConsignor: "",
    currentPlaceOfConsignor: "",
  });

  useEffect(() => {
    setCancelEWayBillComment("");
    setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (message === "E-Way Bill created successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setGenerateEWayBill({
        token,
        client_code: null,
        invoice_id: null,
        invoice_type: type,
        sub_supply_type: "",
        transporter_id: "",
        transporter_name: "",
        transporter_document_number: "",
        transporter_document_date: "",
        transportation_mode: "",
        transportation_distance: "",
        vehicle_number: "",
        vehicle_type: "",
        transaction_type: "Regular",
        type,
      });
    }
    if (message === "E-Way Bill has been cancelled successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setCancelEWayBillComment("");
      setEWayBillRadioValue(CANCEL_EWAYBILL_OPTION[0]?.id);
    }
    if (message === "E-Way Bill has been extended successfully") {
      setShowFillForm(false);
      setShowCancelFillForm(false);
      setShowExtendFillForm(false);
      setGenerateEWayBill({
        token,
        client_code: null,
        invoice_id: null,
        invoice_type: type,
        sub_supply_type: "",
        transporter_id: "",
        transporter_name: "",
        transporter_document_number: "",
        transporter_document_date: "",
        transportation_mode: "",
        transportation_distance: "",
        vehicle_number: "",
        vehicle_type: "",
        transaction_type: "Regular",
        type,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  useEffect(() => {
    setIsEWayPresent(data?.eway_bill_status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.eway_bill_status]);

  useEffect(() => {
    setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
      return {
        ...prv,
        transportation_distance:
          data?.transportation_details?.transportation_distance,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.transportation_details?.transportation_distance]);

  const submitEWayBillForm = () => {
    const errors: any = {};
    if (generateEWayBill?.sub_supply_type?.length == 0) {
      errors.subSupply = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          subSupply: "error",
        };
      });
    }

    if (
      generateEWayBill?.transporter_document_date?.length == 0 ||
      !generateEWayBill?.transporter_document_date
    ) {
      errors.transporterDocumentDate = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          transporterDocumentDate: "error",
        };
      });
    }

    if (!generateEWayBill?.transportation_mode) {
      errors.transportationMode = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          transportationMode: "error",
        };
      });
    }
    if (
      generateEWayBill?.transportation_mode === "Road" &&
      generateEWayBill?.vehicle_type?.length === 0
    ) {
      if (generateEWayBill?.vehicle_type?.length === 0) {
        errors.vehicleType = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            vehicleType: "error",
          };
        });
      }
    }
    if (
      generateEWayBill?.transportation_mode === "Road" &&
      generateEWayBill?.vehicle_number?.length === 0
    ) {
      if (generateEWayBill?.vehicle_number?.length === 0) {
        errors.vehicleNumber = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            vehicleNumber: "error",
          };
        });
      }
    }

    if (
      (generateEWayBill?.transportation_mode === "Air" ||
        generateEWayBill?.transportation_mode === "Ship" ||
        generateEWayBill?.transportation_mode === "Rail") &&
      (generateEWayBill?.transporter_document_date?.length === 0 ||
        generateEWayBill?.transporter_document_number?.length === 0)
    ) {
      if (generateEWayBill?.transporter_document_date?.length === 0) {
        errors.transporterDocumentDate = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            transporterDocumentDate: "error",
          };
        });
      }
      if (generateEWayBill?.transporter_document_number?.length === 0) {
        errors.transporterDocumentNumber = "error";
        setInputDetailsError((prv: any) => {
          return {
            ...prv,
            transporterDocumentNumber: "error",
          };
        });
      }
    }

    if (Object.keys(errors).length > 0) {
      toast.error("Please Fill Required Fields!", {
        duration: 2000,
      });
      setInputDetailsError(errors);
    } else {
      handleEWayBillGenerate();
    }
  };
  const changeHeaders = (name: string) => {
    switch (name) {
      case "total_assessable_value":
        return "Total Assessable";
      case "total_cgst_value":
        return "Total CGST";
      case "total_sgst_value":
        return "Total SGST";
      case "total_igst_value":
        return "Total IGST";
      case "taxable_amount":
        return "Taxable Value";
      case "total_discount":
        return "Total Discount";
      case "total_invoice_value":
        return "Total Value";
      case "number_of_item":
        return "Number of Item";
      case "document_type":
        return "Document Type";
      case "document_number":
        return "Voucher/Invoice Number";
      case "document_date":
        return "Voucher/Invoice Date";
      case "address1":
        return "Address 1";
      case "address2":
        return "Address 2";
      case "legal_name":
        return "Legal Name";
      case "trade_name":
        return "Trade Name";
      case "location":
        return "Location";
      case "pincode":
        return "Pin Code";
      case "gstin":
        return "GSTIN";
      case "state_code":
        return "State Code";
      case "email":
        return "Email";
      case "phone_number":
        return "Phone Number";
      case "item_serial_number":
        return "Serial No.";
      case "product_description":
        return "Description as per Bill";
      case "unit":
        return "Unit";
      case "place_of_supply":
        return "Place of Supply";
      case "quantity":
        return "Quantity";
      case "hsn_code":
        return "HSN/SAC Code";
      case "discount":
        return "Discount";
      case "unit_price":
        return "Unit Price";
      case "total_amount":
        return "Total Amount";
      case "assessable_value":
        return "Assessable Value";
      case "gst_rate":
        return "Gst Percentage";
      case "igst_amount":
        return "IGST Amount";
      case "sgst_amount":
        return "SGST Amount";
      case "cgst_amount":
        return "CGST Amount";
      case "total_item_value":
        return "Total Value";
      case "is_service":
        return "Service";
      case "gstin_of_consignor":
        return "GSTIN ";
      case "legal_name_of_consignor":
        return "Legal Name ";
      case "address1_of_consignor":
        return "Address 1";
      case "address2_of_consignor":
        return "Address 2";
      case "place_of_consignor":
        return "City";
      case "pincode_of_consignor":
        return "Pincode";
      case "state_of_consignor":
        return "State";
      case "actual_from_state_name":
        return "Actual From State Name";
      case "gstin_of_consignee":
        return "GSTIN ";
      case "legal_name_of_consignee":
        return "Legal Name ";
      case "address1_of_consignee":
        return "Address 1 ";
      case "address2_of_consignee":
        return "Address 2 ";
      case "place_of_consignee":
        return "City";
      case "pincode_of_consignee":
        return "Pincode";
      case "state_of_supply":
        return "Place of Supply";
      case "actual_to_state_name":
        return "Actual to State Name";
      case "cess_amount":
        return "CESS Amount";
      case "cess_nonadvol_value":
        return "Cess Nonadvol Value";
      case "transporter_id":
        return "Transporter ID";
      case "transporter_name":
        return "Transporter Name";
      case "transporter_document_number":
        return "Transporter Document Number";
      case "transporter_document_date":
        return "Transporter Document Date";
      case "transportation_mode":
        return "Transportation Mode";
      case "transportation_distance":
        return "Transportation Distance";
      case "vehicle_type":
        return "Vehicle Type";
      default:
        return name;
    }
  };
  const createRows = (data: any, obj: any) => {
    let finalData = data?.filter(
      (item: string) =>
        item != "cess_nonadvol_value" &&
        item != "actual_from_state_name" &&
        item != "actual_to_state_name"
    );
    let rowCreated = finalData?.map((item: any) => {
      return (
        <div className="one-input">
          <div className="inside-row-e-invoice">{changeHeaders(item)}</div>
          <div className="row-einvoice">
            {obj[item]
              ? item === "document_date"
                ? formatDate(obj[item])
                : obj[item]
              : "--"}
          </div>
        </div>
      );
    });
    return rowCreated;
  };

  const handleExtendShow = () => {
    setShowExtendFillForm(true);
    setShowCancelFillForm(false);
    setShowFillForm(false);
  };

  const handleCancelShow = () => {
    setShowCancelFillForm(true);
    setShowExtendFillForm(false);
    setShowFillForm(false);
  };

  const EWayBillModalBody = () => {
    return !fetching ? (
      <div className="e-way-bill">
        {isEWayPresent === 1 && !!data?.eway_bill_number ? (
          <div className="row ml-4 mt-1 mb-1 irn">
            {" "}
            <span style={{ fontWeight: "500" }}>E-Way Bill No. </span> :{" "}
            {data?.eway_bill_number}
          </div>
        ) : null}
        <div
          className={
            isEWayPresent === 1 || eWayBillError?.length
              ? "reverse-einvoice"
              : "reverse-einvoice"
          }
        >
          {/* left side preview  */}

          <div
            style={
              // (isEWayPresent === 1 && isEWayBillCancel) || eWayBillError?.length
              // ?
              { width: "68%" }
              // : {}
            }
          >
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img src={ValueIcon} alt="ValueIcon" className="mr-2" /> Value
                Details
              </div>

              {data?.value_details ? (
                <div
                  className={
                    isEWayPresent === 1 || eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.value_details),
                    data?.value_details
                  )}
                </div>
              ) : null}
            </div>
            {/* document  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                {" "}
                <img src={DocumentIcon} alt="DocumentIcon" className="mr-2" />
                Document Details
              </div>
              {data?.document_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.document_details),
                    data?.document_details
                  )}
                </div>
              ) : null}
            </div>

            {/* buyer Details  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img
                  src={BusinessAddressIcon}
                  alt="BusinessAddressIcon"
                  className="mr-2"
                />
                {data?.supply_type === "INWARD"
                  ? "Customer/Supplier Details (Consignor)"
                  : "Business Addresses Details (Consignor)"}
              </div>
              {data?.consignor_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.consignor_details),
                    data?.consignor_details
                  )}
                </div>
              ) : null}
            </div>

            {/* seller Details  */}
            <div className="details-box mb-3">
              <div className={"sub-heading-e-invoice mt-3"}>
                <img
                  src={CustomerSupplierDetailsIcon}
                  alt="CustomerSupplierDetailsIcon"
                  className="mr-2"
                />
                {data?.supply_type === "INWARD"
                  ? "Business Addresses Details (Consignee)"
                  : "Customer/Supplier Details (Consignee)"}
              </div>
              {data?.consignee_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.consignee_details),
                    data?.consignee_details
                  )}
                </div>
              ) : null}
            </div>
            <div
              className={
                (data?.eway_bill_status === 1 ||
                  data?.eway_bill_status === 3) &&
                data?.transportation_details
                  ? `details-box mb-3`
                  : ""
              }
            >
              {/* TRANSPORTATION DEATILS  */}
              {data?.eway_bill_status === 1 || data?.eway_bill_status === 3 ? (
                <div className={"sub-heading-e-invoice mt-3"}>
                  <img src={TruckIcon} alt="TruckIconIcon" className="mr-2" />
                  Transportation Deatils
                </div>
              ) : (
                ""
              )}
              {(data?.eway_bill_status === 1 || data?.eway_bill_status === 3) &&
              data?.transportation_details ? (
                <div
                  className={
                    isEWayPresent === 1 ||
                    isEWayPresent === 2 ||
                    data?.eway_bill_status === 3 ||
                    eWayBillError?.length
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.transportation_details),
                    data?.transportation_details
                  )}
                </div>
              ) : null}
            </div>
            {/* item list  */}

            <div className={"sub-heading-e-invoice m-0"}>Item Details</div>
            {data?.itemList?.length ? (
              <div
                className={"inside-einvoice-items jobsType"}
                style={{ overflowX: "scroll" }}
              >
                <table className="table thead-light table-bordered">
                  <thead className="text-left no-wrap sticky-table-header">
                    <TableHeader tableHeader={EWayBill_HEADERS} />
                  </thead>
                  <tbody>
                    <EWayBillTableData
                      tableHeaders={EWayBill_HEADERS}
                      data={data?.itemList}
                    />
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* comment box  */}
          <div style={{ width: "32%" }}>
            {eWayBillError?.length ? (
              <div>
                {eWayBillError?.length && (
                  <div className="p-2">
                    {eWayBillError?.split("||")?.map((item: any) => {
                      return (
                        <div
                          className="mt-2 mb-2 error-msg p-2"
                          style={{
                            border: "1px solid #ba4916",
                            backgroundColor: "#fef2ed",
                            borderRadius: "6px",
                          }}
                        >
                          <span className="mr-1">
                            <img src={RedErrorIcon} alt="error" />
                          </span>
                          <span className="ml-2">{item}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            <>
              {!showFillForm && !showCancelForm && !showExtendFillForm ? (
                <>
                  {data?.eway_bill_valid_date &&
                  (data?.eway_bill_status === 1 ||
                    data?.eway_bill_status === 3) ? (
                    <div className="e-way-action-box e-way-valid mb-3">
                      <img src={InfoViolet} alt="i-icon" /> This E-Way Bill is{" "}
                      valid upto {data?.eway_bill_valid_date}
                    </div>
                  ) : (
                    ""
                  )}
                  <EWayBillAction
                    setShowFillForm={setShowFillForm}
                    data={data}
                    isEWayBillGenerate={isEWayBillGenerate}
                  />
                </>
              ) : (
                ""
              )}
              {showCancelForm ? (
                <EWayBillCancel
                  data={data}
                  eWayBillAt={eWayBillAt}
                  cancelEWayBillComment={cancelEWayBillComment}
                  radioValue={eWayBillRadioValue}
                  setCancelEWayBillComment={setCancelEWayBillComment}
                  setRadioValue={setEWayBillRadioValue}
                  isEWayPresent={isEWayPresent}
                  isEWayBillCancel={isEWayBillCancel}
                  handleCancelEWayBill={handleCancelEWayBill}
                />
              ) : showExtendFillForm ? (
                <EWayBillExtend
                  clientCode={clientCode}
                  data={data}
                  eWayBillInvoiceId={eWayBillInvoiceId}
                  type={type}
                  eWayBillExtend={eWayBillExtendForm}
                  setEWayBillExtend={setEWayBillExtendForm}
                  inputDetailsError={extendInputDetailsError}
                  setInputDetailsError={setExtendInputDetailsError}
                />
              ) : (
                ""
              )}
            </>
            {/* /////transportation deatils */}
            {showFillForm &&
            isEWayBillGenerate &&
            data?.eway_bill_pdf_url?.length === 0 ? (
              <EWayBillGenerate
                generateEWayBill={generateEWayBill}
                inputDetailsError={inputDetailsError}
                setInputDetailsError={setInputDetailsError}
                setGenerateEWayBill={setGenerateEWayBill}
                submitEWayBillForm={submitEWayBillForm}
                data={data}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="row col-md-12">
        <TableLoader Rows={14} ColumnPerRow={3} />
      </div>
    );
  };
  return (
    <div>
      <FullScreenDialog
        error={eWayBillError}
        success={success}
        downloadBtn={
          isEWayBillDownload
            ? {
                url: data?.eway_bill_pdf_url
                  ? `${data?.eway_bill_status === 1 ? `https://` : ""}${
                      data?.eway_bill_pdf_url
                    }`
                  : "",
                name: ``,
              }
            : null
        }
        disabled={
          data?.eway_bill_status === 0 ||
          data?.eway_bill_status === 2 ||
          data?.eway_bill_status === 3
            ? false
            : cancelEWayBillComment?.trim()?.length === 0
        }
        onClose={togglePreviewEWayBill}
        loading={fetching}
        title={
          eWayBillError?.length ? "Errors In E-Way Bill" : "View E-Way Bill"
        }
        option1Btn={
          fetching ||
          data?.eway_bill_status === 0 ||
          data?.eway_bill_status === 2
            ? ""
            : isEWayBillExtend
            ? "Extend E-Way Bill"
            : ""
        }
        option2Btn={
          fetching ||
          data?.eway_bill_status === 0 ||
          data?.eway_bill_status === 2
            ? ""
            : isEWayBillCancel
            ? "Cancel E-Way Bill"
            : ""
        }
        option1BtnFn={() => {
          handleExtendShow();
        }}
        option2BtnFn={() => {
          handleCancelShow();
        }}
        optionBtn1State={showExtendFillForm}
        optionBtn2State={showCancelForm}
        body={EWayBillModalBody}
        closeAfterLoading={
          isEWayPresent === 1 || isEWayPresent === 2
            ? "cancelling..."
            : "sending..."
        }
        onSubmit={() => {
          //commented for future use
          // if (data?.eway_bill_status === 1) {
          //   handleCancelEWayBill();
          // }
        }}
      />
    </div>
  );
};

export default EWayBillModal;
